import { Button } from '@ws/shared/components';
import { AlignMore24, Sync20, List20, Check20 } from '@ws/shared/icons';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ResolutionContext } from '../../context';
import { useSidebar } from '../../hooks';
import { isMobile } from '../../modules/getResolution';
import { TAppState } from '../../redux';
import { setGlobalIsCompiled } from '../../redux/general/general.actions';
import { eventBus, BusEventType } from '../../utils/EventBus';

import styles from './MobileActionPanel.module.css';
import { classes } from 'classifizer';

export function MobileActionPanelComponent() {
  const dispatch = useDispatch();
  const { isCompiled } = useSelector((state: TAppState) => state.general);
  const { selected } = useSelector((state: TAppState) => state.editor);
  const { onOpen: onSidebarOpen } = useSidebar();

  const [isSaveBtnVisible, setIsSaveBtnVisible] = useState(false);

  const handleCompilationToggle = () => dispatch(setGlobalIsCompiled({ isCompiled: !isCompiled }));

  const completeEditMode = () => {
    eventBus.emit(BusEventType.COMPLETE_EDIT_BTN_CLICKED, undefined);
    setIsSaveBtnVisible(false);
  };

  useEffect(() => {
    const onUnmount = () => {
      setIsSaveBtnVisible(false);
    };

    const onMount = () => {
      setIsSaveBtnVisible(true);
    };

    eventBus.on(BusEventType.COMPLETE_EDIT_BTN_MOUNTED, onMount);
    eventBus.on(BusEventType.COMPLETE_EDIT_BTN_UNMOUNTED, onUnmount);
    return () => {
      eventBus.off(BusEventType.COMPLETE_EDIT_BTN_MOUNTED, onMount);
      eventBus.off(BusEventType.COMPLETE_EDIT_BTN_UNMOUNTED, onUnmount);
    };
  }, []);

  return (
    <aside className={styles['panel']}>
      <Button
        color="secondary"
        onClick={onSidebarOpen}
        icon={<AlignMore24 color="textator_primary" />}
      />

      <div className={styles['panel__right-buttons']}>
        {selected && selected.type === 'collection' && (
          <Button
            className={styles['panel__right-button']}
            color={isCompiled ? 'secondary' : 'primary'}
            onClick={handleCompilationToggle}
            icon={isCompiled ? <List20 /> : <Sync20 />}
          />
        )}

        {isSaveBtnVisible && (
          <Button
            className={classes(styles['panel__right-button'], styles['save-button'])}
            color="secondary"
            onClick={completeEditMode}
            icon={<Check20 color="other_white" />}
          />
        )}
      </div>
    </aside>
  );
}

export function MobileActionPanel() {
  const { resolution } = useContext(ResolutionContext);
  const mobile = isMobile(resolution);

  if (!mobile) {
    return null;
  }

  return <MobileActionPanelComponent />;
}
